import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import MenuQuery from 'Query/Menu.query';
import {
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps,
    MenuContainer as SourceMenuContainer
} from 'SourceComponent/Menu/Menu.container';
import { toggleMenuMobile } from 'Store/Menu/Menu.action';
import { CustomerType } from 'Type/Account.type';
import { MixType, ModsType } from 'Type/Common.type';
import { noopFn } from 'Util/Common';
import MenuHelper from 'Util/Menu';

/** @namespace PeggysagePwa/Component/Menu/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state),
    customer: state.MyAccountReducer.customer,
    isCustomerTypeStudentEnabled: state.ConfigReducer.students_active
});

/** @namespace PeggysagePwa/Component/Menu/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch),
    toggleMenuMobile: (state) => dispatch(toggleMenuMobile(state))
});

/** @namespace PeggysagePwa/Component/Menu/Container */
export class MenuContainer extends SourceMenuContainer {
    static propTypes = {
        ...SourceMenuContainer.propTypes,
        mix: MixType,
        mods: ModsType,
        onClose: PropTypes.func,
        customer: CustomerType.isRequired,
        isCustomerTypeStudentEnabled: PropTypes.bool.isRequired,
        toggleMenuMobile: PropTypes.func.isRequired
    };

    static defaultProps = {
        mix: {},
        mods: {},
        onClose: noopFn
    };

    containerFunctions = {
        ...this.containerFunctions,
        onSubMenuBackButtonClick: this.onSubMenuBackButtonClick.bind(this)
    };

    onLinkClickCallback = this.onLinkClick.bind(this);

    /**
     * Override: add vars to state
     * @param props
     * @private
     */
    __construct(props) {
        super.__construct(props);

        this.state = {
            ...this.state,
            activeLevel: 0,
            areLinksClickEventListenersAdded: false
        };
    }

    componentDidUpdate(prevProps) {
        const {
            mods: { isVisible },
            customer: { group_id: groupId = 0 } = {}
        } = this.props;
        const {
            mods: { isVisible: prevIsVisible },
            customer: { group_id: prevGroupId = 0 } = {}
        } = prevProps;

        if (isVisible !== prevIsVisible) {
            this.resetMenu();
        }

        if (groupId !== prevGroupId) {
            this._getMenu(false);
        }
    }

    componentWillUnmount() {
        this.removeLinksClickEventListeners();
    }

    /**
     * Override: do not fetch data from cache when the user logs in or logs out
     * + reset event listeners on menu links
     * @param takeFromWindowCache
     * @private
     */
    _getMenu(takeFromWindowCache = true) {
        this.fetchData(
            [MenuQuery.getQuery(this._getMenuOptions())],
            ({ menu }) => this.setState({
                menu: MenuHelper.reduce(menu)
            }, this.initLinksClickEventListeners.bind(this)),
            noopFn,
            takeFromWindowCache
        );
    }

    onLinkClick() {
        const { toggleMenuMobile } = this.props;

        toggleMenuMobile(false);
    }

    initLinksClickEventListeners() {
        const { device: { isMobile } } = this.props;

        if (isMobile) {
            const links = document.querySelectorAll('.Menu-MainCategories a');
            if (links.length) {
                links.forEach((elt) => {
                    elt.removeEventListener('click', this.onLinkClickCallback);
                    elt.addEventListener('click', this.onLinkClickCallback);
                });
            }
        }
    }

    removeLinksClickEventListeners() {
        const links = document.querySelectorAll('.Menu-MainCategories a');
        if (links.length) {
            links.forEach((elt) => {
                elt.removeEventListener('click', this.onLinkClickCallback);
            });
        }
    }

    /**
     * Override
     * @returns {{mods: (*|MenuContainer.props.mods), mix: (*|MenuContainer.props.mix), activeLevel: (*|number)}}
     */
    containerProps() {
        const {
            mix,
            mods,
            isCustomerTypeStudentEnabled,
            customer
        } = this.props;
        const { activeLevel } = this.state;

        return {
            ...super.containerProps(),
            mix,
            mods,
            isCustomerTypeStudentEnabled,
            customer,
            activeLevel
        };
    }

    /**
     * Override: on mobile, change level of menu (slide panel)
     * @param e
     * @param activeSubcategory
     * @param closeAction boolean
     */
    handleSubcategoryClick(e, activeSubcategory/* , closeAction = false */) {
        const { device } = this.props;
        const { activeMenuItemsStack/* , activeLevel */ } = this.state;
        const { item_id } = activeSubcategory;

        const newActiveMenuItemsStack = this.getNewActiveMenuItemsStack(activeMenuItemsStack, item_id);

        if (device.isMobile) {
            // const newActiveLevel = closeAction ? activeLevel - 1 : activeLevel + 1;
            // this.setState({ activeLevel: newActiveLevel });

            this.setState({ activeLevel: newActiveMenuItemsStack.length });
            document.querySelector('.Menu-MenuWrapper').scrollTo({ top: 0 });
        }

        super.handleSubcategoryClick(e, activeSubcategory);
    }

    onSubMenuBackButtonClick(e, category) {
        e.stopPropagation();

        this.handleSubcategoryClick(e, category, true);
    }

    resetActiveLevel() {
        this.setState({ activeLevel: 0 });
    }

    resetMenu() {
        this.setState({
            activeLevel: 0,
            activeMenuItemsStack: []
        });
    }

    /**
     * Override
     */
    closeMenu() {
        const { onClose } = this.props;

        this.resetMenu();

        onClose();
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuContainer);
